import React from 'react';
import {
  Typography,
  Grid,
  FormControl,
  TextField,
  makeStyles,
  Card,
  CardContent,
  Box,
  Chip,
} from '@material-ui/core';
import { Permission } from 'lib/Model/Permission';

const useStyles = makeStyles((theme) => ({
  searchContainer: {
    marginBottom: theme.spacing(3),
  },
  permissionCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  permissionCardContent: {
    flexGrow: 1,
  },
  permissionTitle: {
    marginBottom: theme.spacing(1),
  },
  userCountChip: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  clickableCard: {
    cursor: 'pointer',
    transition: theme.transitions.create(['box-shadow', 'transform'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      boxShadow: theme.shadows[4],
      transform: 'translateY(-2px)',
    },
  },
}));

interface PermissionsTabProps {
  permissionsData: Permission[] | undefined;
  permissionsSearch: string | undefined;
  setPermissionsSearch: (value: string | undefined) => void;
  onPermissionClick: (permissionSlug: string) => void;
}

const PermissionsTab: React.FC<PermissionsTabProps> = ({
  permissionsData,
  permissionsSearch,
  setPermissionsSearch,
  onPermissionClick,
}) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.searchContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <TextField
                variant="outlined"
                label="Search Permissions"
                fullWidth
                placeholder="Enter permission name"
                InputLabelProps={{ shrink: true }}
                value={permissionsSearch || ''}
                onChange={(e) =>
                  setPermissionsSearch(e.target.value || undefined)
                }
              />
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={2}>
        {permissionsData?.map((permission) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={permission.id}>
            <Card
              className={`${classes.permissionCard} ${classes.clickableCard}`}
              onClick={() => onPermissionClick(permission.slug)}
            >
              <Chip
                label={`${permission.user_count} ${
                  permission.user_count === 1 ? 'user' : 'users'
                }`}
                size="small"
                className={classes.userCountChip}
                color="primary"
              />
              <CardContent className={classes.permissionCardContent}>
                <Typography
                  variant="h6"
                  component="h3"
                  className={classes.permissionTitle}
                >
                  {permission.name}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {permission.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default PermissionsTab;
